import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../../constants/app.constants";
import { RingFenceResponse, UpdateRingFenceRequest } from "../../models/ringFence";
import {
  GetAllRingFencesKey,
  GetRingFenceKey,
  GetRingFencesByScenarioKey
} from "./constants";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/ring-fence`;

const updateRingFence = async (
  data: UpdateRingFenceRequest
): Promise<RingFenceResponse> => {
  if (!data._id) {
    throw new Error("Ring fence ID is required");
  }

  const response = await axios.put<RingFenceResponse>(
    `${API_URL}/${data._id.$oid}`,
    data
  );
  return response.data;
};

const useUpdateRingFence = () => {
  const queryClient = useQueryClient();

  return useMutation<RingFenceResponse, AxiosError, UpdateRingFenceRequest, unknown>(
    updateRingFence,
    {
      onSuccess: async (data, variables) => {
        // Invalidate related queries
        await queryClient.invalidateQueries([GetRingFenceKey, variables._id.$oid]);
        await queryClient.invalidateQueries([
          GetRingFencesByScenarioKey,
          variables.scenarioId
        ]);
        await queryClient.invalidateQueries(GetAllRingFencesKey);
      }
    }
  );
};

export default useUpdateRingFence;
